import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";
import Search from "../../../../assets/images/search-button.svg";
import { CheckboxOptionType } from "antd";
import {
  ButtonShape,
  ButtonSize,
  ButtonType,
} from "../../../../enums/ButtonAttributesEnums";
import * as Yup from "yup";
import { regexPatterns } from "../../../../utils/regexUtil";

interface DropdownOptionsProps {
  label: string;
  value: string;
}
interface getJobLeadsFieldsProps {
  jobDropdownOptions: DropdownOptionsProps[];
  customerDropdownOptions: DropdownOptionsProps[];
  contactDetails: DropdownOptionsProps[];
  salesPersonDropdownOptions: DropdownOptionsProps[];
  handleSelectedCustomer: (selectedCustomer: string) => void;
  handleIsExemptRadio: (value: string) => void;
  handleIsReceivedRadio: (value: string) => void;
  isReceivedValue: string;
  isExemptValue: string;
  handleCustomerModalOpen: () => void;
  handleContactModalOpen: () => void;
  editable: boolean;
  importJobId: string;
}

export const getJobLeadsFields = ({
  jobDropdownOptions,
  customerDropdownOptions,
  contactDetails,
  salesPersonDropdownOptions,
  handleSelectedCustomer,
  handleIsReceivedRadio,
  handleIsExemptRadio,
  isExemptValue,
  isReceivedValue,
  handleCustomerModalOpen,
  handleContactModalOpen,
  editable,
  importJobId,
}: getJobLeadsFieldsProps) => [
  {
    name: "importDataFrom",
    type: InputfieldTypes.LABEL,
    label: "Import Data From",
    width: "full",
    visible: !editable,
  },
  {
    name: "importJobId",
    type: InputfieldTypes.SELECT_CUSTOM_FIELD,
    label: "Job",
    required: false,
    placeholder: "Select",
    width: "1/3",
    induceSpace: true,
    options: jobDropdownOptions,
    buttonLabel: "Apply",
    disabled: !importJobId,
    visible: !editable,
  },
  {
    name: "jobDetails",
    type: InputfieldTypes.LABEL,
    label: "Job Details",
    width: "full",
  },
  {
    name: "customerAccount",
    type: InputfieldTypes.SELECT_CUSTOM_FIELD,
    label: "Customer Account",
    required: true,
    placeholder: "Select Customer",
    width: "1/3",
    induceSpace: true,
    options: customerDropdownOptions,
    handleOnSelect: handleSelectedCustomer,
    customButtonLabel: "+ Add Customer",
    handleModalOpen: handleCustomerModalOpen,
  },
  {
    name: "jobName",
    type: InputfieldTypes.TEXT,
    label: "Job Name",
    required: true,
    placeholder: "Enter job name",
    maxLength: 100,
    width: "1/3",
  },
  {
    name: "contactName",
    type: InputfieldTypes.SELECT_CUSTOM_FIELD,
    label: "Contact Name",
    required: true,
    placeholder: "Select Contact",
    width: "1/3",
    induceSpace: true,
    options: contactDetails,
    customButtonLabel: "+ Add Contact",
    handleModalOpen: handleContactModalOpen,
  },
  {
    name: "deliveryAddress",
    type: InputfieldTypes.GOOGLE,
    label: "Job Site Address",
    required: true,
    placeholder: "Search",
    width: "1/3",
    suffixContent: <img src={Search} />,
    isDeliveryAddress: true,
  },
  {
    name: "deliveryAddressCoordinates",
    type: InputfieldTypes.TEXT,
    label: "Job Site Coordinates",
    required: true,
    induceSpace: true,
    placeholder: "Enter coordinates",
    width: "1/3",
  },
  {
    name: "salesPerson",
    type: InputfieldTypes.SELECT,
    label: "Sales Person",
    required: true,
    induceSpace: true,
    placeholder: "Select",
    width: "1/3",
    options: salesPersonDropdownOptions,
    showSearch: true,
  },
  {
    name: "projectInformationSheet",
    type: "radio",
    label: "Project Information Sheet",
    required: true,
    placeholder: "Select",
    options: [
      { label: "Received", value: "received" },
      { label: "Not Received", value: "notReceived" },
    ] as CheckboxOptionType[],
    width: "1/4",
    withUpload: true,
    handleOnChange: handleIsReceivedRadio,
    value: isReceivedValue,
  },
  {
    name: "taxExemptStatus",
    type: "radio",
    label: "Tax Exempt Status",
    required: true,
    placeholder: "Select",
    width: "1/4",
    options: [
      { label: "Exempt", value: "exempt" },
      { label: "Not Exempt", value: "notExempt" },
    ] as CheckboxOptionType[],
    withUpload: true,
    handleOnChange: handleIsExemptRadio,
    value: isExemptValue,
  },
  {
    name: "notes",
    type: InputfieldTypes.TEXT_AREA,
    label: "Notes",
    required: false,
    placeholder: "Enter Notes",
    width: "full",
    limit: 500,
  },
];

export const successMessage = {
  fileSubmissionSuccess: "Files Submitted Successfully!",
};

export const errorMessage = {
  fileSubmmisionFailure: "Failed to submit file.",
};

export const UploadDocType = {
  projectDoc: "Project Information Sheet",
  taxDoc: "Tax Exemption Certificate",
  quoteDoc: "Generate Quote",
};

export const fieldNames = {
  CUSTOMER_FIELD: "customerAccount",
  CONTACT_FIELD: "contactName",
};

export const accountTermsOptions = [
  {
    label: "Cash",
    value: "Cash",
  },
  {
    label: "Net 14",
    value: "Net 14",
  },
  {
    label: "Net 30",
    value: "Net 30",
  },
  {
    label: "Custom Input",
    value: "Custom Input",
  },
];

export const addCustomerFieldNames = {
  companyName: "customerCompanyName",
  companyAddress: "customerCompanyAddress",
  companyMail: "customerCompanyMail",
  companyPhone: "customerCompanyPhone",
  companyAccountTerms: "customerCompanyAccountTerms",
  companyNotes: "customerCompanyNotes",
  customTerms: "customPaymentTerms",
};

export const CUSTOM_INPUT = "Custom Input";
export const COMPANY_EXISTS_ERROR = "Customer name already exists";

export const addCustomerModalFields = ({
  paymentTerms = [],
}: {
  paymentTerms?: [];
}) => [
  {
    name: "customerCompanyName",
    label: "Company Name",
    placeHolder: "Enter company name",
    required: true,
    type: InputfieldTypes.ONCHANGE_TEXT,
  },
  {
    name: "customerCompanyAddress",
    label: "Company Mailing Address",
    placeHolder: "Search address",
    required: true,
    type: InputfieldTypes.GOOGLE,
    isCompanyAddress: true,
  },
  {
    name: "customerCompanyMail",
    label: "Office Email",
    placeHolder: "Enter email address",
    required: false,
    type: InputfieldTypes.ONCHANGE_TEXT,
  },
  {
    name: "customerCompanyPhone",
    label: "Office Phone",
    placeHolder: "Enter phone number",
    required: false,
    type: InputfieldTypes.ONCHANGE_TEXT,
  },
  {
    name: "customerCompanyAccountTerms",
    label: "Account Terms",
    placeHolder: "Select",
    required: true,
    type: InputfieldTypes.SELECT,
    options: paymentTerms,
  },
  {
    name: "customPaymentTerms",
    label: "Custom Terms",
    placeholder: "Enter terms",
    type: InputfieldTypes.TEXT,
    formattedNumberType: true,
    prefix: "Net ",
  },
];

export const addCustomerContactNotesFields = {
  customerName: "customerCompanyNotes",
  contactName: "contactCompanyNotes",
  label: "Notes",
  placeHolder: "Enter notes",
  required: false,
  type: InputfieldTypes.TEXT_AREA,
};

export const addContactButtonFields = {
  name: "customerAddContactButton",
  label: "+ Add Contact",
  type: ButtonType.PRIMARY,
  shape: ButtonShape.DEFAULT,
};

export const addContactFieldNames = {
  contactFirstName: "contactFirstName",
  contactLastName: "contactLastName",
  contactEmail: "contactEmail",
  contactPhone: "contactPhone",
  contactNotes: "contactCompanyNotes",
  roleId: "roleId",
};

export const addContactModalFields = ({
  contactRoles = [],
  handleOpenAddRoleModal,
}: {
  contactRoles?: [];
}) => [
  {
    name: "contactFirstName",
    label: "First Name",
    placeHolder: "Enter first name",
    required: true,
    type: InputfieldTypes.ONCHANGE_TEXT,
  },
  {
    name: "contactLastName",
    label: "Last Name",
    placeHolder: "Enter last name",
    required: true,
    type: InputfieldTypes.ONCHANGE_TEXT,
  },
  {
    name: "contactEmail",
    label: "Email",
    placeHolder: "Enter email address",
    type: InputfieldTypes.ONCHANGE_TEXT,
  },
  {
    name: "contactPhone",
    label: "Phone",
    placeHolder: "Enter phone number",
    type: InputfieldTypes.ONCHANGE_TEXT,
  },
  {
    name: "roleId",
    type: InputfieldTypes.SELECT_CUSTOM_FIELD,
    label: "Role",
    placeHolder: "Select",
    options: contactRoles,
    customButtonLabel: "+ Add Role",
    handleModalOpen: handleOpenAddRoleModal,
  },
];

export const addContactFormValidation = Yup.object({
  contactFirstName: Yup.string().required("required"),
  contactLastName: Yup.string().required("required"),
  contactEmail: Yup.string()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .notRequired()
    .matches(regexPatterns.emailRegex, "Must be a valid email address"),
  contactPhone: Yup.string()
    .transform((value) => {
      if (value === "") return null;
      return value ? value.replace(/[^\d]/g, "") : value;
    })
    .notRequired()
    .min(10, "Phone number must be 10 digits!"),
}).test(
  "one-contact-method",
  "Either email or phone number is required",
  function (value) {
    const { contactEmail, contactPhone } = value || {};
    if (contactEmail || contactPhone) {
      return true;
    }
    return this.createError({
      path: "contactEmail",
      message: "Either email or phone number is required",
    });
  },
);

export const addCustomerFormValidation = Yup.object({
  customerCompanyName: Yup.string().required("required"),
  customerCompanyAddress: Yup.string().required("required"),
  customerCompanyMail: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .notRequired()
    .matches(regexPatterns.emailRegex, "Must be a valid email address"),
  customerCompanyPhone: Yup.string()
    .transform((value) => {
      if (value === "") return null;
      return value ? value.replace(/[^\d]/g, "") : value;
    })
    .notRequired()
    .min(10, "Phone number must be 10 digits!"),
  customerCompanyAccountTerms: Yup.string().required("required"),
  customPaymentTerms: Yup.string().when("customerCompanyAccountTerms", {
    is: (val: string) => val === "Custom Input",
    then: () => Yup.string().required("This is a required for custom terms"),
    otherwise: () => Yup.string().notRequired(),
  }),
}).test(
  "one-contact-method",
  "Either email or phone number is required",
  function (value) {
    const { customerCompanyMail, customerCompanyPhone } = value || {};
    if (customerCompanyMail || customerCompanyPhone) {
      return true;
    }
    return this.createError({
      path: "customerCompanyMail",
      message: "Either email or phone number is required",
    });
  },
);

export const customerAddMessages = {
  success: "Customer added successfully!",
  failure: "Failed to add new customer",
};
export const contactAddMessages = {
  success: "Contact added successfully!",
  failure: "Failed to add new contact",
};

export const contactEditMessages = {
  success: "Contact updated successfully!",
  failure: "Failed to update contact",
};

export const customStylingSelectField = {
  width: "100%",
  background: "#F1F5F9",
  borderColor: "#F1F5F9",
  textShadow: "none",
  color: "grey",
  display: "flex",
  justifyContent: "start",
};

export const customerModalFields = {
  name: "Add Customer",
  zIndex: 100,
  width: "800px",
};

export const contactModalFields = {
  addTitle: "Add Contact",
  editTitle: "Edit Contact",
  zIndex: 101,
  width: "800px",
};

export const UploadModalConst = {
  UPLOAD_BTN_TEXT: "Upload",
  MODAL_TITLE: "Upload File",
  MODAL_WIDTH: "761px",
};

export const addRoleValidation = Yup.object().shape({
  roleName: Yup.string().required("Role name is required"),
});
